function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
export default function LogoSvg(props) {
  var _props$size, _props$size2, _props$size3, _props$size4, _props$backgroundColo, _props$accent;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    logoIsHovered = _useState2[0],
    setLogoIsHovered = _useState2[1];
  var padding = 0;
  var finalSize = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 40;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      width: (_props$size2 = props.size) !== null && _props$size2 !== void 0 ? _props$size2 : 40,
      height: (_props$size3 = props.size) !== null && _props$size3 !== void 0 ? _props$size3 : 40,
      borderRadius: (_props$size4 = props.size) !== null && _props$size4 !== void 0 ? _props$size4 : 40,
      backgroundColor: "".concat((_props$backgroundColo = props.backgroundColor) !== null && _props$backgroundColo !== void 0 ? _props$backgroundColo : 'transparent'),
      overflow: "hidden",
      padding: padding
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: finalSize,
    height: finalSize,
    viewBox: "0 0 524 524",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "55",
    stroke: (_props$accent = props.accent) !== null && _props$accent !== void 0 ? _props$accent : 'hotpink',
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "262",
    cy: "262",
    r: "234.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.815 388.344C361.788 496.825 99.8011 399.82 165.12 224.668C208.648 108.123 353.579 136.75 346.768 243.845C316.435 405.52 97.5136 293.238 194.468 177.663"
  }))));
}